angular.module('kareo.ui.shared.directives.chrome-header.active-container', [])
  .directive('activeContainer', [
    '$timeout', function ($timeout) {
      return {
        restrict: 'A', link(scope, element, attrs, ctrls) {
          var doc = angular.element(element[0].ownerDocument);

          function documentClickHandler(event) {
            scope.$apply(() => {
              var documentElement = event.target;
              while (documentElement != null && documentElement !== doc[0] && documentElement !== element[0]) {
                documentElement = documentElement.parentNode;
              }
              if (documentElement == null || documentElement === doc[0]) {
                scope.isActive = false;
              }
            });
          }

          scope.$watch('isActive', (isActive) => {
            if (isActive === true) {
              $timeout(() => {
                doc.bind('click', documentClickHandler);
              }, 0);
            } else {
              doc.unbind('click', documentClickHandler);
            }
          });
          scope.$on('$destroy', () => {
            doc.unbind('click', documentClickHandler);
          });
        }, scope: {
          isActive: '=activeContainer'
        }
      };
    }]);
